module.exports = __webpack_public_path__ + "static/img/A.2977dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/country/strategy/A.png
// module id = 3Am1
// module chunks = 4